import { AppLink } from '@common/components/Link/AppLink';
import { ComputedTab } from '@common/types/link';
import { Tabs } from '@radix-ui/themes';

import styles from '@styles';

export const TableTabTrigger = <T extends string>({
    option,
    to,
}: Partial<ComputedTab<T>>) => {
    if (!option || !to) return null;

    return (
        <AppLink to={to}>
            <Tabs.Trigger className={styles.link} value={option.value}>
                {option.label}
            </Tabs.Trigger>
        </AppLink>
    );
};
